import React, { FC } from 'react';
import { FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { UploadedFiles } from './constants';
import {
  TopSection,
  Title,
  ControlBar,
  PlatformSection,
  SaveButton,
  HiddenInput,
} from './styles';
import { PlatformItem } from './PlatformItem';
import { PLATFORMS } from './constants';

interface EditingStateProps {
  uploadedFiles: UploadedFiles;
  uploadProgress: any;
  hasActiveUploads: boolean;
  isSaveDisabled: boolean;
  inputRefs: {
    unity: React.RefObject<HTMLInputElement>;
    windows: React.RefObject<HTMLInputElement>;
    macos: React.RefObject<HTMLInputElement>;
    android: React.RefObject<HTMLInputElement>;
  };
  onFileUpload: (platform: string, file: File) => void;
  onCancelUpload: (platform: string) => void;
  onSave: () => void;
}

export const EditingState: FC<EditingStateProps> = ({
  uploadedFiles,
  uploadProgress,
  hasActiveUploads,
  isSaveDisabled,
  inputRefs,
  onFileUpload,
  onCancelUpload,
  onSave,
}) => {
  const { t } = useTranslation();

  const handleFileSelect = (platform: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileUpload(platform, file);
    }
  };

  return (
    <>
      <TopSection>
        <Title>{t('room_launch.title')}</Title>
      </TopSection>
      
      <ControlBar>
        <FlexBox style={{display: 'flex', height: '100%', placeItems: 'center', borderRight: '1px solid #838382', paddingRight: 16}}>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2Z" fill="#909090"/>
        <path d="M16 6.5L8 11.5667V20.2222M16 6.5V15.1556M16 6.5L24 11.5667V20.2222M16 15.1556L8 20.2222M16 15.1556L24 20.2222M8 20.2222L16 25.5L24 20.2222" stroke="#909090" stroke-width="2"/>
        <path d="M16.2286 15.5L8 20.2826L16.2286 25.5L24 20.2826L16.2286 15.5Z" fill="#909090"/>
        </svg>
        </FlexBox>
        
        <PlatformSection>
          {PLATFORMS.map((platform) => (
            <React.Fragment key={platform.key}>
              <PlatformItem
                platform={platform}
                isUploading={uploadProgress[platform.key]?.isUploading || false}
                progress={uploadProgress[platform.key]?.progress || 0}
                hasFile={!!uploadedFiles[platform.key]?.fileId}
                onAddClick={() => inputRefs[platform.key as keyof typeof inputRefs].current?.click()}
                onCancelClick={() => onCancelUpload(platform.key)}
              />
              
              <HiddenInput
                ref={inputRefs[platform.key as keyof typeof inputRefs]}
                type="file"
                accept={platform.accept}
                onChange={handleFileSelect(platform.key)}
              />
            </React.Fragment>
          ))}
        </PlatformSection>
          
        <SaveButton onClick={onSave} disabled={isSaveDisabled}>
            {t('room_launch.save_button')}
        </SaveButton>
      </ControlBar>
    </>
  );
};
import React, { FC } from 'react';
import { FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { UploadedFiles } from './constants';
import {
  TopSection,
  Title,
  ControlBar,
  PlatformSection,
  SaveButton,
  HiddenInput,
} from './styles';
import { PlatformItem } from './PlatformItem';
import { PLATFORMS } from './constants';

interface EditingStateProps {
  uploadedFiles: UploadedFiles;
  uploadProgress: any;
  hasActiveUploads: boolean;
  isSaveDisabled: boolean;
  inputRefs: {
    unity: React.RefObject<HTMLInputElement>;
    windows: React.RefObject<HTMLInputElement>;
    macos: React.RefObject<HTMLInputElement>;
    android: React.RefObject<HTMLInputElement>;
  };
  onFileUpload: (platform: string, file: File) => void;
  onCancelUpload: (platform: string) => void;
  onSave: () => void;
}

export const EditingState: FC<EditingStateProps> = ({
  uploadedFiles,
  uploadProgress,
  hasActiveUploads,
  isSaveDisabled,
  inputRefs,
  onFileUpload,
  onCancelUpload,
  onSave,
}) => {
  const { t } = useTranslation();

  const handleFileSelect = (platform: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileUpload(platform, file);
    }
  };

  return (
    <>
      <TopSection>
        <Title>{t('room_launch.title')}</Title>
      </TopSection>
      
      <ControlBar>
        <FlexBox style={{display: 'flex', height: '100%', placeItems: 'center', borderRight: '1px solid #838382', paddingRight: 16}}>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2Z" fill="#909090"/>
        <path d="M16 6.5L8 11.5667V20.2222M16 6.5V15.1556M16 6.5L24 11.5667V20.2222M16 15.1556L8 20.2222M16 15.1556L24 20.2222M8 20.2222L16 25.5L24 20.2222" stroke="#909090" stroke-width="2"/>
        <path d="M16.2286 15.5L8 20.2826L16.2286 25.5L24 20.2826L16.2286 15.5Z" fill="#909090"/>
        </svg>
        </FlexBox>
        
        <PlatformSection>
          {PLATFORMS.map((platform) => (
            <React.Fragment key={platform.key}>
              <PlatformItem
                platform={platform}
                isUploading={uploadProgress[platform.key]?.isUploading || false}
                progress={uploadProgress[platform.key]?.progress || 0}
                hasFile={!!uploadedFiles[platform.key]?.fileId}
                onAddClick={() => inputRefs[platform.key as keyof typeof inputRefs].current?.click()}
                onCancelClick={() => onCancelUpload(platform.key)}
              />
              
              <HiddenInput
                ref={inputRefs[platform.key as keyof typeof inputRefs]}
                type="file"
                accept={platform.accept}
                onChange={handleFileSelect(platform.key)}
              />
            </React.Fragment>
          ))}
        </PlatformSection>
          
        <SaveButton onClick={onSave} disabled={isSaveDisabled}>
            {t('room_launch.save_button')}
        </SaveButton>
      </ControlBar>
    </>
  );
};
